import { render, staticRenderFns } from "./MarkAsSeen.vue?vue&type=template&id=2b8fa780&scoped=true&"
import script from "./MarkAsSeen.vue?vue&type=script&lang=ts&"
export * from "./MarkAsSeen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8fa780",
  null
  
)

export default component.exports